var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M8.244 11.104a4.219 4.219 0 1 0-4.676 0 6.74 6.74 0 0 0-3.32 2.651.562.562 0 1 0 .942.614 5.626 5.626 0 0 1 9.432 0 .563.563 0 0 0 .942-.614 6.74 6.74 0 0 0-3.32-2.652m-5.432-3.51a3.094 3.094 0 1 1 6.188 0 3.094 3.094 0 0 1-6.188 0m14.776 6.94a.563.563 0 0 1-.778-.165 5.61 5.61 0 0 0-4.716-2.557.563.563 0 0 1 0-1.125 3.094 3.094 0 1 0-1.15-5.967.563.563 0 1 1-.417-1.044 4.219 4.219 0 0 1 3.905 7.428 6.74 6.74 0 0 1 3.32 2.651.56.56 0 0 1-.164.778"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsAccess);
export default __webpack_public_path__ + "static/media/actions-access.04ebaac5a7b852578440aaa038c2c76a.svg";
export { ForwardRef as ReactComponent };